/* eslint-disable complexity */
export const typescriptObjectParser = (format: string): [string, string][] => {
  const keyValuePairs: [string, string][] = [];

  // State of the algorithm
  let lastKey = '';
  let lastValue = '';
  let shouldAppendToKey = true;

  const pushPair = () => {
    if (lastKey) keyValuePairs.push([lastKey, lastValue]);
    lastKey = '';
    lastValue = '';
    shouldAppendToKey = true;
  };

  // Complex -- but working -- logic
  let depth = 0;
  format.split('').forEach((char) => {
    if (char === '{') {
      depth += 1;
      if (depth > 1) lastValue += char;
    } else if (char === '}') {
      if (depth > 1) lastValue += char;
      depth -= 1;
      if (depth === 1) pushPair();
    } else if (char === ':') {
      shouldAppendToKey = false;
      if (depth > 1) lastValue += char;
    } else if (char === ',') {
      if (depth === 1) pushPair();
      else lastValue += char;
    } else if (char === ' ') {
      // Do nothing
    } else if (shouldAppendToKey) lastKey += char;
    else lastValue += char;
  });
  pushPair();

  return keyValuePairs;
};
